module.exports = __webpack_public_path__ + "static/media/Car.2f116744.svg";